import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AssignToMeService } from '../assign-to-me.service';
import { assignToMeAction, assignToMeFailureAction, assignToMeSuccessAction } from './assign-to-me.actions';

@Injectable()
export class AssignToMeEffects {
  assignToMe$ = createEffect(() => this.actions$.pipe(
    ofType(assignToMeAction),
    switchMap(action =>
      this.assignToMeService.create(action.payload).pipe(
        map(data => assignToMeSuccessAction({ data })),
        catchError(error => of(assignToMeFailureAction({ error }))),
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private assignToMeService: AssignToMeService,
  ) {
  }
}
